import { useState } from 'react';
import styled from 'styled-components';

import { useInterval } from '#/utils/useInterval';

declare global {
  interface Window {
    /** type `PARADEX__enableDebugMonitor()` in dev console in a browser to bring up DebugMonitor */
    PARADEX__enableDebugMonitor: () => void;
  }
}

let isActive =
  String(FE_DOMAIN).includes('localhost') && IS_RUNNING_IN_CYPRESS !== 'true';
const HISTORY_SIZE = 3;

const history: Record<string, string[]> = {};
export const pushValue = (id: string, value: () => string) => {
  if (!isActive) return;
  if (history[id] == null) history[id] = [];
  history[id]!.push(value());
  history[id] = history[id]!.slice(-HISTORY_SIZE);
};

export default function DebugMonitor() {
  const [isOpen, setIsOpen] = useState(isActive);
  const [state, setState] = useState(history);

  window.PARADEX__enableDebugMonitor = () => {
    isActive = true;
    setIsOpen(true);
  };

  useInterval(() => setState({ ...history }), isOpen ? 250 : null);

  if (!isOpen) return null;

  return (
    <Container>
      <Title>
        Debug Utils <Close onClick={() => setIsOpen(false)} />
      </Title>
      {Object.keys(state).map((id) => (
        <Value key={id} id={id} state={state} />
      ))}
    </Container>
  );
}

function Value(props: { id: string; state: typeof history }) {
  const { id, state } = props;
  const value = state[id]?.join(',') ?? '-';

  return (
    <div css="margin-bottom: 4px">
      <span>{id}:</span>
      <br />
      <span>{value}</span>
    </div>
  );
}

const Close = styled.button.attrs({ children: 'X' })``;

const Title = styled.h4`
  font-size: 13px;
  margin: 0;
  margin-bottom: 8px;

  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const Container = styled.div`
  z-index: 1000;
  position: fixed;
  bottom: 30px;
  right: 10px;

  width: 300px;
  min-height: 20px;
  background-color: gray;
  opacity: 0.5;

  padding: 4px;
  font-size: 12px;
`;
